/* tslint:disable */

/**
 */
export class MomoParamMBS {
    partnerCode?: string;
    timestamp?: string;
    hash?: string;
}
